var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.field && _vm.field.message)?_c('el-tooltip',{attrs:{"effect":"light","content":(_vm.field && _vm.field.message) || ''}},[_c('i',{staticClass:"POAEditor__icon-error el-icon-warning"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }